import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 5,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'last_message_user_name', type: 'string' }]
    })
  ]
}
